import traslateDialogReducer from './traslateDialogReducer';

export default traslateDialogReducer;